export const matchesSearch = (search: string, values: (string | null | undefined)[]): boolean => {
  const query = search.trim().toLowerCase();
  if (!query) {
    return true;
  }

  return values.some((value) => value?.toLowerCase().includes(query));
};
